import { Linking } from 'react-native'

const openInNewWebTab = (uri) => Linking.openURL(uri)
export default openInNewWebTab
